import { render, staticRenderFns } from "./MediakitCollectionDialog.vue?vue&type=template&id=3d6d0492&"
import script from "./MediakitCollectionDialog.vue?vue&type=script&lang=js&"
export * from "./MediakitCollectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports